var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size,"color":_vm.color}},[_c('v-img',{attrs:{"src":_vm.avatar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }